import React, { useState } from 'react'

const CUISINES = [
  { value: "indian", label: "Indian" },
  { value: "chinese", label: "Chinese" },
  { value: "italian", label: "Italian" },
  { value: "mexican", label: "Mexican" },
  { value: "thai", label: "Thai" },
  { value: "japanese", label: "Japanese" },
  { value: "korean", label: "Korean" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "indonesian", label: "Indonesian" },
  { value: "malaysian", label: "Malaysian" },
  { value: "singaporean", label: "Singaporean" },
  { value: "american", label: "American" },
  { value: "british", label: "British" },
  { value: "french", label: "French" },
  { value: "spanish", label: "Spanish" },
  { value: "greek", label: "Greek" },
  { value: "turkish", label: "Turkish" },
  { value: "lebanese", label: "Lebanese" },
  { value: "mediterranean", label: "Mediterranean" },
  { value: "middle_eastern", label: "Middle Eastern" },
  { value: "arabic", label: "Arabic" },
  { value: "persian", label: "Persian (Iranian)" },
  { value: "german", label: "German" },
  { value: "russian", label: "Russian" },
  { value: "polish", label: "Polish" },
  { value: "ukrainian", label: "Ukrainian" },
  { value: "hungarian", label: "Hungarian" },
  { value: "brazilian", label: "Brazilian" },
  { value: "argentinian", label: "Argentinian" },
  { value: "peruvian", label: "Peruvian" },
  { value: "colombian", label: "Colombian" },
  { value: "caribbean", label: "Caribbean" },
  { value: "cuban", label: "Cuban" },
  { value: "jamaican", label: "Jamaican" },
  { value: "ethiopian", label: "Ethiopian" },
  { value: "moroccan", label: "Moroccan" },
  { value: "tunisian", label: "Tunisian" },
  { value: "south_african", label: "South African" },
  { value: "nigerian", label: "Nigerian" },
  { value: "kenyan", label: "Kenyan" },
  { value: "australian", label: "Australian" },
  { value: "new_zealand", label: "New Zealand" },
  { value: "fusion", label: "Fusion" },
  { value: "continental", label: "Continental" },
  { value: "fast_food", label: "Fast Food" },
  { value: "street_food", label: "Street Food" },
  { value: "bbq", label: "BBQ" },
  { value: "grill", label: "Grill" },
  { value: "seafood", label: "Seafood" },
  { value: "vegetarian", label: "Vegetarian" },
  { value: "vegan", label: "Vegan" },
  { value: "desserts", label: "Desserts" },
  { value: "bakery", label: "Bakery" },
  { value: "cafe", label: "Cafe" },
  { value: "beverages", label: "Beverages" }
]

const AMBIENCE_FILTERS = [
  { emoji: '🏙️', label: 'Rooftop',          value: 'rooftop'          },
  { emoji: '🌿', label: 'Open Garden',       value: 'open-garden'      },
  { emoji: '🌤️', label: 'Open Roof Ground',  value: 'open-roof-ground' },
  { emoji: '🕯️', label: 'Candlelit',         value: 'candlelit'        },
  { emoji: '🎵', label: 'Live Music',        value: 'live-music'       },
  { emoji: '🌊', label: 'Waterfront',        value: 'waterfront'       },
  { emoji: '🏡', label: 'Rustic Cottage',    value: 'rustic-cottage'   },
  { emoji: '🌃', label: 'Night View',        value: 'night-view'       },
  { emoji: '🪵', label: 'Bonfire Seating',   value: 'bonfire'          },
  { emoji: '🌁', label: 'Terrace',           value: 'terrace'          },
  { emoji: '🏖️', label: 'Beach Shack',       value: 'beach'            },
  { emoji: '📚', label: 'Book Café',         value: 'book-cafe'        },
  { emoji: '🎨', label: 'Art Café',          value: 'art-cafe'         },
  { emoji: '🐾', label: 'Pet Friendly',      value: 'pet-friendly'     },
  { emoji: '💻', label: 'Work-Friendly',     value: 'work-friendly'    },
  { emoji: '🌙', label: 'Late Night',        value: 'late-night'       },
]

const VIBE_FILTERS = [
  { emoji: '🎭', label: 'Malayalam Theme',   value: 'malayalam'     },
  { emoji: '🌺', label: 'Kannada Theme',     value: 'kannada'       },
  { emoji: '🪔', label: 'Tamil Theme',       value: 'tamil'         },
  { emoji: '🦚', label: 'Telugu Theme',      value: 'telugu'        },
  { emoji: '🏮', label: 'Chinese Theme',     value: 'chinese-vibe'  },
  { emoji: '⛩️', label: 'Japanese Theme',    value: 'japanese-vibe' },
  { emoji: '🕌', label: 'Arabian Nights',    value: 'arabian'       },
  { emoji: '🎪', label: 'Rajasthani Theme',  value: 'rajasthani'    },
  { emoji: '🛕', label: 'Bengali Theme',     value: 'bengali'       },
  { emoji: '🌍', label: 'African Theme',     value: 'african'       },
  { emoji: '🥐', label: 'Parisian Bistro',   value: 'parisian'      },
  { emoji: '🍝', label: 'Italian Trattoria', value: 'italian-vibe'  },
  { emoji: '🌯', label: 'Mediterranean',     value: 'mediterranean' },
  { emoji: '🎸', label: 'Punjabi Dhaba',     value: 'punjabi-dhaba' },
  { emoji: '🏔️', label: 'Himalayan Theme',   value: 'himalayan'     },
  { emoji: '🎋', label: 'Thai Theme',        value: 'thai-vibe'     },
  { emoji: '🌵', label: 'Mexican Cantina',   value: 'mexican-vibe'  },
  { emoji: '☘️', label: 'Irish Pub Vibe',    value: 'irish'         },
]

const OCCASION_FILTERS = [
  { emoji: '🎂', label: 'Birthday Party',        value: 'birthday'          },
  { emoji: '💍', label: 'Anniversary',           value: 'anniversary'       },
  { emoji: '🎊', label: 'Promotion Party',       value: 'promotion'         },
  { emoji: '🏢', label: 'Corporate Party',       value: 'corporate'         },
  { emoji: '🎓', label: 'Graduation Party',      value: 'graduation'        },
  { emoji: '👋', label: 'Farewell Party',        value: 'farewell'          },
  { emoji: '👨‍👩‍👧‍👦', label: 'Family Get-together', value: 'family'      },
  { emoji: '🥳', label: 'Celebration Dinner',    value: 'celebration'       },
  { emoji: '🍾', label: 'Achievement Party',     value: 'achievement'       },
  { emoji: '💑', label: 'Date Night',            value: 'date'              },
  { emoji: '🤝', label: 'Business Meeting',      value: 'business_meeting'  },
  { emoji: '🎤', label: 'Event Hosting',         value: 'event_hosting'     },
  { emoji: '🎶', label: 'After Party',           value: 'after_party'       },
  { emoji: '🍻', label: 'Friends Hangout',       value: 'friends'           },
  { emoji: '🙏', label: 'Festive Gathering',     value: 'festival'          },
]

// Cuisines had no emoji in the original list — give them a neutral default
const withEmoji = (list, fallback = '🍴') =>
  list.map(o => (o.emoji ? o : { ...o, emoji: fallback }))

/**
 * Reusable click-to-toggle chip group.
 * - Renders every option up front (no dropdown, no search box).
 * - Clicking a chip toggles it in/out of the selection.
 * - Keeps the same output shape react-select produced: an array of
 *   { value, label } objects, so nothing downstream (AddProperty's
 *   FIELD_REGISTRY, summaryRow, save fns) needs to change.
 */
function ToggleChipGroup({ title, options, selected, onToggle }) {
  const selectedValues = new Set(selected.map(s => s.value))

  return (
    <div className="sc-group">
      <div className="sc-group-header">
        <span className="sc-group-title">{title}</span>
        {selected.length > 0 && (
          <span className="sc-group-count">{selected.length} selected</span>
        )}
      </div>
      <div className="sc-chip-grid">
        {options.map(opt => {
          const isActive = selectedValues.has(opt.value)
          return (
            <button
              key={opt.value}
              type="button"
              className={`sc-chip ${isActive ? 'sc-chip--active' : ''}`}
              onClick={() => onToggle(opt)}
              aria-pressed={isActive}
            >
              {opt.emoji && <span className="sc-chip-emoji">{opt.emoji}</span>}
              <span className="sc-chip-label">{opt.label}</span>
              {isActive && <span className="sc-chip-check">✓</span>}
            </button>
          )
        })}
      </div>
    </div>
  )
}

const SelectCousine = ({ setCousine, setAmbience, setVibe, setOccasion }) => {
  const [cuisineSel,  setCuisineSel]  = useState([])
  const [vibeSel,     setVibeSel]     = useState([])
  const [ambienceSel, setAmbienceSel] = useState([])
  const [occasionSel, setOccasionSel] = useState([])

  const toggle = (opt, selected, setSelected, setParent) => {
    const exists = selected.some(s => s.value === opt.value)
    const next = exists
      ? selected.filter(s => s.value !== opt.value)
      : [...selected, opt]
    setSelected(next)
    setParent(next)
  }

  return (
    <div className="sc-root">
      <ToggleChipGroup
        title="Cuisine"
        options={withEmoji(CUISINES, '🍽️')}
        selected={cuisineSel}
        onToggle={(opt) => toggle(opt, cuisineSel, setCuisineSel, setCousine)}
      />

      <ToggleChipGroup
        title="Vibe"
        options={VIBE_FILTERS}
        selected={vibeSel}
        onToggle={(opt) => toggle(opt, vibeSel, setVibeSel, setVibe)}
      />

      <ToggleChipGroup
        title="Ambience"
        options={AMBIENCE_FILTERS}
        selected={ambienceSel}
        onToggle={(opt) => toggle(opt, ambienceSel, setAmbienceSel, setAmbience)}
      />

      <ToggleChipGroup
        title="Occasion"
        options={OCCASION_FILTERS}
        selected={occasionSel}
        onToggle={(opt) => toggle(opt, occasionSel, setOccasionSel, setOccasion)}
      />

      <style>{`
        .sc-root {
          display: flex;
          flex-direction: column;
          gap: 28px;
        }
        .sc-group-header {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          margin-bottom: 10px;
        }
        .sc-group-title {
          font-size: 14px;
          font-weight: 600;
          color: var(--ap-text, #1f2937);
        }
        .sc-group-count {
          font-size: 12px;
          color: var(--ap-muted, #6b7280);
        }
        .sc-chip-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .sc-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 7px 12px;
          border-radius: 999px;
          border: 1.5px solid var(--ap-border, #e5e7eb);
          background: var(--ap-surface, #fff);
          color: var(--ap-text, #374151);
          font-size: 13.5px;
          line-height: 1.2;
          cursor: pointer;
          user-select: none;
          transition: background 0.15s ease, border-color 0.15s ease,
                      color 0.15s ease, transform 0.1s ease;
        }
        .sc-chip:hover {
          border-color: var(--ap-accent, #6366f1);
        }
        .sc-chip:active {
          transform: scale(0.97);
        }
        .sc-chip--active {
          background: var(--ap-accent, #6366f1);
          border-color: var(--ap-accent, #6366f1);
          color: #fff;
        }
        .sc-chip-emoji {
          font-size: 14px;
        }
        .sc-chip-check {
          font-size: 11px;
          margin-left: 2px;
        }
      `}</style>
    </div>
  )
}

export default SelectCousine